import { useEffect, useState } from 'react'

/** The current time, refreshed every `ms` (for elapsed-time displays). */
export function useNow(ms = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms)
    return () => clearInterval(t)
  }, [ms])
  return now
}

/** Poll quickly while something is active, slowly otherwise. */
export function pollWhile(active: boolean, fast = 2_000, slow = 15_000): number {
  return active ? fast : slow
}
